import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IntakeService } from '../../shared/intake.service';
import { NotifierService } from '../../shared/notifier.service';
import { AuthService } from '../../shared/auth.service';
import { IntakeAddress } from '../../interfaces/intake';

/** The tenant's Intake address: full block on My Company, one-line strip on the Intake list. */
@Component({
  selector: 'bst-intake-address-block',
  templateUrl: './intake-address-block.component.html',
  styleUrls: ['./intake-address-block.component.scss'],
  standalone: false
})
export class IntakeAddressBlockComponent implements OnInit {
  @Input() mode: 'company' | 'strip' = 'company';

  address: IntakeAddress = null;
  busy = false;

  constructor(private intake: IntakeService,
              private notifier: NotifierService,
              private translate: TranslateService,
              private auth: AuthService) {}

  get canRotate(): boolean {
    return this.auth.isAdmin;
  }

  /** D1 answers {address: null, masked: null} while the tenant has no active address. */
  get hasAddress(): boolean {
    return !!this.address?.address;
  }

  async ngOnInit() {
    this.address = await (this.mode === 'strip' ? this.intake.addressQuietly() : this.intake.getAddress()).catch(() => null);
  }

  async rotate() {
    if (this.busy || !this.canRotate) { return; }
    this.busy = true;
    try {
      // Creating the first address breaks nothing, so only a real rotate asks.
      const ok = !this.hasAddress || await this.notifier.confirm(
        'intake.address.rotate_confirm_title',
        this.translate.instant('intake.address.rotate_confirm_body'),
        'intake.address.rotate_yes',
        'danger',
        'no',
      );
      if (!ok) { return; }
      const fresh = await this.intake.rotateAddress().catch(() => null);
      if (!fresh) { return; }
      this.address = fresh;
    } finally {
      this.busy = false;
    }
  }
}
